import axios from 'axios';

export const clientContactBrandApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-contact-brands`,
    headers: {
        'Content-Type': 'application/json'
    }
})